<template>
  <div>
    <b-modal v-model="show" no-close-on-backdrop hide-header-close no-close-on-esc :title="titulo" size="sm">
      <b-form-row>{{ mensagem }}</b-form-row>
      <template v-slot:modal-footer>
        <div class="row">
          <b-btn-group class="mr-2">
            <b-btn block variant="default" @click="recuse" :disabled="clicked">{{nao}}</b-btn>
          </b-btn-group>
          <b-btn-group class="mr-2">
            <b-btn block variant="primary" @click="confirm" :disabled="clicked">{{sim}}</b-btn>
          </b-btn-group>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      clicked: false
    }
  },
  props: {
    titulo: String,
    mensagem: { default: 'Confirmar ação?' },
    sim: { default: 'Sim' },
    nao: { default: 'Não' },
    show: { default: false },
    conteudo: Object,
    motrarObservacao: { default: false }
  },
  watch: {
    show: function (val) {
      if (val) {
        this.clicked = false
      }
    }
  },
  methods: {
    confirm () {
      this.clicked = true
      this.$api.UI.Confirm()
    },
    recuse () {
      this.clicked = true
      this.$api.UI.Recuse()
    }
  }
}
</script>
